// extracted by mini-css-extract-plugin
export default {"actions-container":"MessageActions_actions-container__J2gVB"};